import script from "./payroll-sync.vue?vue&type=script&setup=true&lang=js"
export * from "./payroll-sync.vue?vue&type=script&setup=true&lang=js"

import "./payroll-sync.vue?vue&type=style&index=0&id=21169f16&scoped=true&lang=css"

import exportComponent from "/home/runner/work/inventflux-frontend/inventflux-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-21169f16"]])

export default __exports__